"use client";

import { useEffect } from "react";
import { apiRequestExternal } from "../api/apiRequestExternal";
import { capturePartnerCodeFromUrl } from "../util/partnerProgram";
import { captureUtmSourceFromUrl } from "../util/utmSource";

/**
 * Records ?ref= landings for partner analytics and stores ref in a cookie for signup/OAuth.
 * Also captures utm_source from the URL for registration attribution.
 */
export default function PartnerProgramCapture() {
  useEffect(() => {
    capturePartnerCodeFromUrl();
    captureUtmSourceFromUrl();
    const sp = new URLSearchParams(window.location.search);
    const fromUrl = (sp.get("ref") || sp.get("utm_campaign") || "").trim().toLowerCase();
    if (!fromUrl || fromUrl.length < 8) return;
    if (!/^[a-z0-9]+$/.test(fromUrl)) return;
    const adminToken = process.env.NEXT_PUBLIC_PROJECT_ID;
    if (!adminToken) return;
    const url = `${process.env.NEXT_PUBLIC_COMPOSER_URL}/v1/public/global/misc/referral-partner/landing`;
    void apiRequestExternal(
      url,
      "POST",
      { code: fromUrl },
      { Authorization: adminToken },
      false,
      false
    ).catch(() => {});
  }, []);
  return null;
}
